<template>
  <div class="container container-fluid">
    <div v-if="showComponentData">
      <div class="text-left">
        <h4>Datos de tercero</h4>
      </div>
      <div class="row">
        <!-- NOMBRE DE TERCERO -->
        <div v-if="isFieldVisible('third_driver_name')" class="col-md-3 mt-3">
          <div class="form-group bordered">
            <label for="third_driver_name" class="form-label text-left">{{ getFieldDescription('third_driver_name') }}</label>
            <input
              type="text"
              class="form-control"
              required="required"
              name="third_driver_name"
              v-model="formData.third_driver_name"
              maxlength="255"
              @input="() => emitFieldChanged('third_driver_name')"
            />
          </div>
        </div>
        <!-- DNI DE TERCERO -->
        <div v-if="isFieldVisible('third_driver_dni')" class="col-md-3 mt-3">
          <div class="form-group bordered">
            <label for="third_driver_dni" class="form-label text-left">{{ getFieldDescription('third_driver_dni') }}</label>
            <input
              type="number"
              class="form-control"
              required="required"
              name="third_driver_dni"
              v-model="formData.third_driver_dni"
              maxlength="8"
              @input="() => emitFieldChanged('third_driver_dni')"
            />
          </div>
        </div>
        <!-- TEL DE TERCERO -->
        <div v-if="isFieldVisible('third_driver_phone')" class="col-md-3 mt-3">
          <div class="form-group bordered">
            <label for="third_driver_phone" class="form-label text-left">{{ getFieldDescription('third_driver_phone') }}</label>
            <input
              type="text"
              class="form-control"
              required="required"
              name="third_driver_phone"
              v-model="formData.third_driver_phone"
              maxlength="10"
              @input="() => emitFieldChanged('third_driver_phone')"
            />
          </div>
        </div>
        <!-- PARENTEZCO DE TERCERO -->
        <div v-if="isFieldVisible('third_driver_relation')" class="col-md-3 mt-3">
          <div class="form-group bordered">
            <label for="third_driver_relation" class="form-label text-left">{{ getFieldDescription('third_driver_relation') }}</label>
            <input
              type="text"
              class="form-control"
              required="required"
              name="third_driver_relation"
              v-model="formData.third_driver_relation"
              maxlength="255"
              @input="() => emitFieldChanged('third_driver_relation')"
            />
          </div>
        </div>
        <!-- MARCA DE VEHICULO DE TERCERO -->
       <!--  <div v-if="isFieldVisible('third_driver_vehicle_mark')" class="col-md-3 mt-3">
          <div class="form-group bordered">
            <label for="third_driver_vehicle_mark" class="form-label text-left">{{ getFieldDescription('third_driver_vehicle_mark') }}</label>
            <input
              type="text"
              class="form-control"
              required="required"
              name="third_driver_vehicle_mark"
              v-model="formData.third_driver_vehicle_mark"
              maxlength="150"
              @input="() => emitFieldChanged('third_driver_vehicle_mark')"
            />
          </div>
        </div> -->
        <!-- MARCA DE VEHICULO DE TERCERO -->
        <!-- <div v-if="isFieldVisible('third_driver_vehicle_model')" class="col-md-3 mt-3">
          <div class="form-group bordered">
            <label for="third_driver_vehicle_model" class="form-label text-left">{{ getFieldDescription('third_driver_vehicle_model') }}</label>
            <input
              type="text"
              class="form-control"
              required="required"
              name="third_driver_vehicle_model"
              v-model="formData.third_driver_vehicle_model"
              maxlength="150"
              @input="() => emitFieldChanged('third_driver_vehicle_model')"
            />
          </div>
        </div> -->
        <!-- DOMINIO DE VEHICULO DE TERCERO -->
        <!-- <div v-if="isFieldVisible('third_driver_vehicle_domain')" class="col-md-3 mt-3">
          <div class="form-group bordered">
            <label for="third_driver_vehicle_domain" class="form-label text-left">{{ getFieldDescription('third_driver_vehicle_domain') }}</label>
            <input
              type="text"
              class="form-control"
              required="required"
              name="third_driver_vehicle_domain"
              v-model="formData.third_driver_vehicle_domain"
              maxlength="150"
              @input="() => emitFieldChanged('third_driver_vehicle_domain')"
            />
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';

export default {
  name: 'FormThirdDriver',
  props: {
    data: Object,
  },
  emits: ['formDataChanged'],
  setup(props, { emit }) {
    const dataCompany = ref(props.data.dataCompaniesForms);
    const dataFormsField = ref(props.data.dataFormsField);
    const showComponentData = ref(false);

    const formData = ref({
      third_driver_name: null,
      third_driver_dni: null,
      third_driver_phone: null,
      third_driver_relation: null,
      /* third_driver_vehicle_mark: null,
      third_driver_vehicle_model: null,
      third_driver_vehicle_domain: null, */
    });

    const cargarDatos = () => {
      try {
        showComponentData.value = (
          dataCompany.value &&
          (dataCompany.value.third_driver_name ||
            dataCompany.value.third_driver_dni ||
            dataCompany.value.third_driver_phone ||
            dataCompany.value.third_driver_relation 
            /* ||
            dataCompany.value.third_driver_vehicle_mark ||
            dataCompany.value.third_driver_vehicle_model ||
            dataCompany.value.third_driver_vehicle_domain */
          )
        );
      } catch (error) {
        console.error(error);
      }
    };

    const isFieldVisible = (fieldName) => {
      return dataCompany.value && dataCompany.value[fieldName] === 1;
    };

    const getFieldDescription = (fieldNameLabel) => {
      let description = fieldNameLabel;
      const dataFormsFieldsWithData = Object.values(dataFormsField.value);
 
      dataFormsFieldsWithData[0].forEach((entry) => {
        const field = entry;
 
        if (field.name === fieldNameLabel) {
          description = field.description;
        }
      });
      return description;
    };

    const emitFieldChanged = () => {
      emit('formDataChanged',  formData.value);
    };

    onMounted(cargarDatos);

    return {
      dataCompany,
      showComponentData,
      isFieldVisible,
      getFieldDescription,
      dataFormsField,
      formData,
      emitFieldChanged,
    };
  },
};
</script>
 
